import { pubText } from "../../i18n/publicTranslation";
import React from "react";
import type { ModelPriceSort } from "../../api/modelPricing";
import PillMenu from "./PillMenu";

export type ModelListSort = ModelPriceSort | "provider";
type Props = { compact?: boolean } & (
  { allowProvider: true; value: ModelListSort; onChange: (value: ModelListSort) => void } |
  { allowProvider?: false; value: ModelPriceSort; onChange: (value: ModelPriceSort) => void }
);

export default function ModelSortMenu(props: Props) {
  const { value, compact = false } = props;
  return (
    <PillMenu<ModelListSort> label={pubText("Sort models")} value={value} mobileSheet onChange={next => {
      if (props.allowProvider) props.onChange(next);
      else if (next !== "provider") props.onChange(next);
    }} compact={compact}
      options={[
      ...(props.allowProvider ? [{ value: "provider" as const, label: "By provider" }] : []),
      { value: "overall", label: "Overall" }, { value: "smartest", label: "Smartest" },
      { value: "creativity", label: "Creativity" }, { value: "fastest", label: "Fastest" },
      { value: "cheapest", label: "Cheapest" },
    ]} />
  );
}
